<kendo-splitter orientation="vertical" style="height: 1000px;">
  <!--The design here all POC,
    we are trying to acive a different goal here
    The design will definetl change a lot as we go long
  -->
  <kendo-splitter-pane>
    <kendo-splitter>
      <!--Template Builder-->
      <kendo-splitter-pane [collapsible]="true" size="35%">
        <div class="pane-content container-fluid" *ngIf="configFormIndex===1">
          <div class="center" style="margin:10px">
            <form>
              <div class="form-group">
                <label for="productType">Product Type</label>
                <kendo-dropdownlist  class="configure_dropdown"
                                    [data]="allV6ProductTypes"
                                    textField="name"
                                    valueField="value"
                                    name="productType"
                                    [(ngModel)]="selectedProductType"
                                    (valueChange)="productTypeChange($event)"
                                    id="productType"
                                    [valuePrimitive]="true">
                </kendo-dropdownlist>
              </div>
            </form>
          </div>
          <!--*ngIf="selectedProductType==='1'"-->
          <div class="center" style="margin:10px" *ngIf="true">
            <form>
              <div class="form-group">
                <label for="productName">Product Name</label><span class="required-field">*</span>
                <input type="text"
                       class="form-control input-width"
                       id="productName"
                       name="productName"
                       [(ngModel)]="productModel.productName">
              </div>
              <div class="form-group">
                <label for="productCode">Product Code</label>
                <input type="text"
                       class="form-control  input-width"
                       id="productCode"
                       name="productCode"
                       [(ngModel)]="productModel.productCode">
              </div>
              <div class="form-group">
                <label for="productDescription">Product Description</label>
                <textarea class="form-control input-width"
                          id="productDescription"
                          name="productDescription"
                          rows="4"
                          [(ngModel)]="productModel.productDescription">
                </textarea>
              </div>
              <div class="form-group">
                <kendo-switch onLabel="Yes"
                              offLabel="No"
                              name="bypassBaseConfig"
                              [(ngModel)]="productModel.bypassBaseConfig">
                </kendo-switch>&nbsp;
                <label class="k-checkbox-label">Bypass Base Config</label>
              </div>
              <div class="form-group">
                <label for="productNameExpression">Configuration Name Expression</label>
                <kendo-dropdownlist  class="configure_dropdown"
                                    [data]="macroList"
                                    textField="name"
                                    valueField="name"
                                    name="productNameExpression"
                                    [filterable]="true"
                                    (filterChange)="macroFilterChangeHandler($event)"
                                    [(ngModel)]="selectedNameMacro"
                                    id="productNameExpression"
                                    [valuePrimitive]="true">
                </kendo-dropdownlist>
              </div>
              <div class="form-group">
                <label for="configAttribute">Product Attribute</label>
                <div class="input-group mb-3">
                  <kendo-dropdownlist  class="configure_dropdown"
                                      id="configAttribute"
                                      [data]="attributeList"
                                      [(ngModel)]="selectedAttributeName"
                                      name="configAttribute"
                                      textField="name"
                                      valueField="name"
                                      [filterable]="true"
                                      (filterChange)="attributeFilterChangeHandler($event)"
                                      [valuePrimitive]="true">
                  </kendo-dropdownlist>&nbsp;&nbsp;&nbsp;
                  <div class="input-group-append">
                    <span class="k-icon k-i-plus k-icon-size"
                          style="color: green;"
                          (click)="addProductAttribute()"
                          title="Add Attribute"></span>
                  </div>
                </div>
              </div>

              <div class="form-group"
                   *ngFor="let pAttr of productModel.productAttributes;let pAttrIndex=index">
                <div class="input-group mb-3">
                  <input type="text" class="form-control input-width" value="{{pAttr.name}}" disabled />
                  <div class="input-group-append">
                    <span class="k-icon k-i-minus k-icon-size " style="color: red;" (click)="removeProductAttribute(pAttrIndex)"
                          title="Delete"></span>
                  </div>
                </div>
               
              </div>

              <div class="form-group">
                <label for="bp2Macro">BP1 Macros</label>
                <div class="input-group mb-3">
                  <kendo-dropdownlist class="configure_dropdown"
                                      id="bp1Macro"
                                      [data]="macroList"
                                      [(ngModel)]="selectedBP1Macro"
                                      name="bp1MacroList"
                                      [filterable]="true"
                                      (filterChange)="macroFilterChangeHandler($event)"
                                      textField="name"
                                      valueField="name"
                                      [valuePrimitive]="true">
                  </kendo-dropdownlist>&nbsp;&nbsp;&nbsp;
                  <div class="input-group-append">
                    <span class="k-icon k-i-plus k-icon-size "
                          style="color: green;"
                          (click)="addBP1Macro()"
                          title="Add BP1 Macro"></span>
                  </div>
                </div>
              </div>

              <div class="form-group"
                   *ngFor="let bp1Macro of productModel.bp1Macros;let bp1MacroIndex=index">
                <div class="input-group mb-3">
                  <div class="input-group-append1">
                    <button class="k-i-arrow-chevron-right k-icon-size form-control"
                            (click)="moveBP1Macro(bp1MacroIndex, 'up')"
                            style="color: black; height: 40px; font-size: 20px"
                            aria-label="Up">
                      <!-- Up Arrow -->
                    </button>
                    <button class="k-i-arrow-chevron-down k-icon-size form-control"
                            (click)="moveBP1Macro(bp1MacroIndex, 'down')"
                            style="color: black; height: 40px; font-size:20px"
                            aria-label="Down">
                      <!--Down Arrow-->
                    </button>
                  </div>
                  <input type="text" class="form-control" value="{{bp1Macro.name}}" disabled />
                  <div class="input-group-append">
                    <span class="k-icon k-i-minus k-icon-size"
                          style="color: red;" (click)="removeBP1Macro(bp1MacroIndex)"
                          title="Delete"></span>
                  </div>
                </div>
              </div>
              
              <div class="form-group">
                <label for="bp2Macro">BP2 Macros</label>
                <div class="input-group mb-3">
                  <kendo-dropdownlist class="configure_dropdown"
                                      id="bp2Macro"
                                      [data]="macroList"
                                      [(ngModel)]="selectedBP2Macro"
                                      name="bp2MacroList"
                                      [filterable]="true"
                                      (filterChange)="macroFilterChangeHandler($event)"
                                      textField="name"
                                      valueField="name"
                                      [valuePrimitive]="true">
                  </kendo-dropdownlist>&nbsp;&nbsp;&nbsp;
                  <div class="input-group-append">
                    <span class="k-icon k-i-plus k-icon-size "
                          style="color: green;"
                          (click)="addBP2Macro()"
                          title="Add BP2Macro"></span>
                  </div>
                </div>
              </div>

              <div class="form-group" *ngFor="let bp2Macro of productModel.bp2Macros;let bp2MacroIndex=index">
                <div class="input-group mb-3">
                  <input type="text" class="form-control" value="{{bp2Macro.name}}" disabled />
                  <div class="input-group-append">
                    <span class="k-icon k-i-minus k-icon-size" style="color: red;" (click)="removeBP2Macro(bp2MacroIndex)"
                          title="Delete"></span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="confirmMacro">Confirm Macros</label>
                <div class="input-group mb-3">
                  <kendo-dropdownlist  class="configure_dropdown"
                                      id="confirmMacro"
                                      [data]="macroList"
                                      [(ngModel)]="selectedConfirmMacro"
                                      name="confirmMacroList"
                                      [filterable]="true"
                                      (filterChange)="macroFilterChangeHandler($event)"
                                      textField="name"
                                      valueField="name"
                                      [valuePrimitive]="true">
                  </kendo-dropdownlist>&nbsp;&nbsp;&nbsp;
                  <div class="input-group-append">
                    <span class="k-icon k-i-plus k-icon-size "
                          style="color: green;"
                          (click)="addConfirmMacro()"
                          title="Add ConfirmMacro"></span>
                  </div>
                </div>
              </div>

              <div class="form-group" *ngFor="let confirmMacro of productModel.confirmMacros;let confirmMacroIndex=index">
                <div class="input-group mb-3">
                  <input type="text" class="form-control" value="{{confirmMacro.name}}" disabled />
                  <div class="input-group-append">
                    <span class="k-icon k-i-minus k-icon-size" style="color: red;" (click)="removeConfirmMacro(confirmMacroIndex)"
                          title="Delete"></span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <button class="m-3 clearKendoButton btn btn-success" (click)="goToManageFrames()"
                        kendoButton>
                  Manage Frames
                </button>
                <button class="m-3 clearKendoButton btn btn-success"
                        (click)="saveConfig()"
                        kendoButton>
                  Save
                </button>
                <button class="m-3 clearKendoButton btn btn-success"
                        (click)="resetConfig()"
                        kendoButton>
                  Reset
                </button>
                <button class="m-3 clearKendoButton btn btn-success"
                        (click)="saveToDatabaseConfig()"
                        kendoButton>
                  Save To Database
                </button>
                <button class="m-3 clearKendoButton btn btn-success"
                        [routerLink]="['/manageProduct']"
                        kendoButton>
                  Back
                </button>
                <button class="m-3 clearKendoButton btn btn-success"
                        (click)="updatePreview()"
                        kendoButton>
                  Update Preview
                </button>
                <kendo-switch onLabel="Yes"
                              offLabel="No"
                              name="userView"
                              [(ngModel)]="productModel.userView">
                </kendo-switch>&nbsp;
                <label class="k-checkbox-label">User View</label>
                <!--<button class="m-3 clearKendoButton btn btn-success"
          (click)="TestUploadKKItems()"
          kendoButton>
    TestUp
  </button>-->
              </div>
            </form>

          </div>
          <!--*ngIf="selectedProductType==='2' || selectedProductType==='3'"-->
          <div class="center" style="margin:10px" *ngIf="false">
            <form>
              <div class="form-group">
                <label for="productName">Product Name</label><span class="required-field">*</span>
                <input type="text"
                       class="form-control input-width"
                       id="productName"
                       name="productName"
                       [(ngModel)]="productModel.productName">
              </div>
              <div class="form-group">
                <label for="productCode">Product Code</label>
                <input type="text"
                       class="form-control  input-width"
                       id="productCode"
                       name="productCode"
                       [(ngModel)]="productModel.productCode">
              </div>
              <div class="form-group">
                <label for="productDescription">Product Description</label>
                <textarea class="form-control input-width"
                          id="productDescription"
                          name="productDescription"
                          rows="4"
                          [(ngModel)]="productModel.productDescription">
                </textarea>
              </div>


              <div class="form-group">
                <label for="bp2Macro">BP1 Macros</label>
                <div class="input-group mb-3">
                  <kendo-dropdownlist class="configure_dropdown"
                                      id="bp1Macro"
                                      [data]="macroList"
                                      [(ngModel)]="selectedBP1Macro"
                                      name="bp1MacroList"
                                      [filterable]="true"
                                      textField="name"
                                      valueField="name"
                                      [valuePrimitive]="true">
                  </kendo-dropdownlist>&nbsp;&nbsp;&nbsp;
                  <div class="input-group-append">
                    <span class="k-icon k-i-plus k-icon-size "
                          style="color: green;"
                          (click)="addBP1Macro()"
                          title="Add BP1 Macro"></span>
                  </div>
                </div>
              </div>

              <div class="form-group"
                   *ngFor="let bp1Macro of productModel.bp1Macros;let bp1MacroIndex=index">
                <div class="input-group mb-3">
                  <input type="text" class="form-control" value="{{bp1Macro.name}}" disabled />
                  <div class="input-group-append">
                    <span class="k-icon k-i-minus k-icon-size "
                          style="color: red;" (click)="removeBP1Macro(bp1MacroIndex)"
                          title="Delete"></span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="bp2Macro">BP2 Macros</label>
                <div class="input-group mb-3">
                  <kendo-dropdownlist  class="configure_dropdown"
                                      id="bp2Macro"
                                      [data]="macroList"
                                      [(ngModel)]="selectedBP2Macro"
                                      name="bp2MacroList"
                                      [filterable]="true"
                                      textField="name"
                                      valueField="name"
                                      [valuePrimitive]="true">
                  </kendo-dropdownlist>&nbsp;&nbsp;&nbsp;
                  <div class="input-group-append">
                    <span class="k-icon k-i-plus k-icon-size "
                          style="color: green;"
                          (click)="addBP2Macro()"
                          title="Add BP2Macro"></span>
                  </div>
                </div>
              </div>

              <div class="form-group" *ngFor="let bp2Macro of productModel.bp2Macros;let bp2MacroIndex=index">
                <div class="input-group mb-3">
                  <input type="text" class="form-control" value="{{bp2Macro.name}}" disabled />
                  <div class="input-group-append">
                    <span class="k-icon k-i-minus k-icon-size" style="color: red;" (click)="removeBP2Macro(bp2MacroIndex)"
                          title="Delete"></span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <!--<button class="m-3 clearKendoButton btn btn-success"
                        (click)="saveConfig()"
                        kendoButton>
                  Save
                </button>-->
                <!--<button class="m-3 clearKendoButton btn btn-success"
                        (click)="resetConfig()"
                        kendoButton>
                  Reset
                </button>-->
                <button class="m-3 clearKendoButton btn btn-success"
                        (click)="saveToDatabaseConfig()"
                        kendoButton>
                  Save To Database
                </button>
                <button class="m-3 clearKendoButton btn btn-success"
                        [routerLink]="['/manageProduct']"
                        kendoButton>
                  Back
                </button>
                <button class="m-3 clearKendoButton btn btn-success"
                        (click)="updatePreview()"
                        kendoButton>
                  Update Preview
                </button>
                <button class="m-3 clearKendoButton btn btn-success"
                        (click)="TestUploadKKItems()"
                        kendoButton>
                  TestUp
                </button>
              </div>
            </form>
          </div>
        </div>

        <div class="pane-content container-fluid" *ngIf="configFormIndex===2">
          <app-manage-frame></app-manage-frame>
        </div>
        <div class="pane-content container-fluid" *ngIf="configFormIndex===3">
          <app-configure-frame></app-configure-frame>
        </div>
      </kendo-splitter-pane>
      <!--Preview Pane-->
      <kendo-splitter-pane [collapsible]="true">
        <app-configure-product></app-configure-product>
      </kendo-splitter-pane>
    </kendo-splitter>
  </kendo-splitter-pane>

</kendo-splitter>



